import { AppMark } from "../components/AppMark";
import { useAuth } from "../hooks/useAuth";
import { useOnlineStatus } from "../hooks/useOnlineStatus";
import { HomeDashboard } from "./HomeDashboard";
import { BottomNav } from "../components/BottomNav";

export function HomePage() {
  const { player, loading, logout } = useAuth();
  const online = useOnlineStatus();

  return (
    <>
      <header className="top-bar">
        <div className="brand"><AppMark />trim log.</div>
        <div className="top-actions">
          <span className="link-btn" data-testid="online-indicator">{online ? "online" : "offline"}</span>
          {player && (
            <button type="button" className="link-btn" onClick={() => { if (confirm("Sign out on this phone? You'll need a new invite from your manager to sign back in.")) logout(); }}>{player.name}</button>
          )}
        </div>
      </header>
      <main className="page">
        {loading ? (
          <div className="center muted" style={{ paddingTop: 80 }}>Loading…</div>
        ) : player ? (
          <HomeDashboard />
        ) : (
          <div className="panel" data-testid="needs-invite">
            <div className="hero"><h1>Sign in with your invite</h1><p>Each person has their own link, so nobody can log runs as you.</p></div>
            <p>Ask your manager to open <strong>Crew</strong> in the console and tap <strong>Invite</strong> next to your name. Scan the QR code on their screen, or open the link they send you.</p>
          </div>
        )}
      </main>
      <BottomNav />
    </>
  );
}
